module.exports = __webpack_public_path__ + "static/media/002.8bf3348f.jpg";